<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Veiculos</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Home',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Veiculos',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>

                    </div>
                    <div class="button-group" style="padding-right: 16px;">
                        <v-btn type="button" color="primary" outlined elevation="0" to="/marcas-modelos">
                            <v-icon left small>mdi-car-info</v-icon>Marcas e modelos</v-btn>
                        <v-btn v-if="$check(['vehicles.create'])" id="btnNew" type="button" color="primary" elevation="0"
                            to="/veiculos/novo">Incluir</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtros de busca</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col cols="3">
                                    <v-text-field dense id="brand" label="Marca" v-model="dataList.filter.brand"
                                        hide-details outlined></v-text-field>
                                </v-col>

                                <v-col cols="3">
                                    <v-text-field dense id="code" label="Frota" v-model="dataList.filter.code"
                                        hide-details outlined></v-text-field>
                                </v-col>

                                <v-col cols="3">
                                    <v-text-field dense id="model" label="Modelo" v-model="dataList.filter.model"
                                        hide-details outlined></v-text-field>
                                </v-col>

                                <v-col cols="3">
                                    <v-text-field dense id="plate" label="Placa" v-model="dataList.filter.plate"
                                        hide-details outlined></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Aplicar filtros</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            @update:items-per-page="pageSizeChanged" @update:page="pageChanged"
                            :server-items-length="dataList.count" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum veiculo encontrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.vehicle_color_id`]="{ item }">
                                <v-chip :color="getColorByType(item.vehicle_color_id)"
                                    :text-color="item.vehicle_color_id === 4 || item.vehicle_color_id === 5 ? 'white' : 'black'">
                                    {{ item.vehicle_color_id | enum(dataset.vehicleColorTypes, "id", "name") }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.code`]="{ item }">
                                <v-avatar v-if="item.image_id" :size="40">
                                    <private-image :id="item.image_id" alt="Imagem do veículo" :size="35" />
                                </v-avatar>
                                <span class="ml-4 list-item-title">{{ item.code }}</span><br />
                            </template>

                            <template v-slot:[`item.odometer`]="{ item }">
                                <span><strong>{{ item.odometer }} KM</strong></span>
                            </template>

                            <template v-slot:[`item.fuel_odometer_margin`]="{ item }">
                                <span>{{ item.fuel_odometer_margin ? `${item.fuel_odometer_margin} KM` : '-' }}</span>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-row align="center">

                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="$check(['vehicles.update'])" v-on="on" @click="editItem(item)" size="large">
                                                mdi-pencil-outline
                                            </v-icon>
                                        </template>
                                        <span>Editar veículo</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="$check(['vehicles.delete'])" v-on="on" @click="openUpdateKmModal(item)" size="large"
                                                class="ml-2">
                                                mdi-counter
                                            </v-icon>
                                        </template>
                                        <span>Atualizar KM</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-on="on" @click="deleteItem(item)" size="large">
                                                mdi-delete
                                            </v-icon>
                                        </template>
                                        <span>Remover veículo</span>
                                    </v-tooltip>

                                </v-row>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>

                <v-divider></v-divider>
            </v-col>
        </v-row>

        <!-- MODAL ATUALIZAR KM -->
        <v-dialog v-model="showUpdateKmModal" max-width="500px">
            <v-card>
                <v-card-title class="mb-3">Atualizar Quilometragem
                    <span v-if="vehicleToUpdateKm.id" class="ml-2 grey--text text--darken-1">ID: {{ vehicleToUpdateKm.id
                    }}</span>
                </v-card-title>
                <v-card-text>
                    <v-form ref="kmForm" v-model="validKmForm">
                        <v-text-field label="Nova Quilometragem (KM)" v-model.number="newKm" type="number"
                            :rules="[v => !!v || 'A quilometragem é obrigatória', v => v >= 0 || 'Não pode ser negativo']"
                            outlined dense hide-details="auto"></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey lighten-1" text @click="closeUpdateKmModal">Cancelar</v-btn>
                    <v-btn color="primary" @click="updateKm" :loading="updatingKm">Enviar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import vehicleColorTypes from "@/common/data/vehicle-color-types.data"

import object from "@/common/util/object"

Vue.use(VueLodash)

export default {
    name: "VehicleList",

    data: () => ({
        dataset: {
            data: {},
            vehicleColorTypes: vehicleColorTypes,
        },
        dataList: {
            filter: {
                brand: "",
                model: "",
                plate: "",
            },
            headers: [
                { text: "Frota", value: "code" },
                { text: "Placa", value: "plate" },
                { text: "Marca", value: "model.brand" },
                { text: "Modelo", value: "model.model" },
                { text: "Ano", value: "year" },
                { text: "Cor", value: "vehicle_color_id" },
                { text: "Motor", value: "model.power" },
                { text: "Combustível", value: "fuel_type" },
                { text: "Margem abastecimento", value: "fuel_odometer_margin" },
                { text: "Quilometragem", value: "odometer" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ['id'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            },
        },
        showUpdateKmModal: false,
        vehicleToUpdateKm: {},
        newKm: null,
        validKmForm: true,
        updatingKm: false,
    }),

    created() {
        this.load();
    },

    methods: {
        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.size = size;
            this.load(true);
        },


        async load() {

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : {};

            var limit = this.dataList.options.itemsPerPage;

            this.dataList.loading = true;

            try {
                const result = await axios.get('/api/v2/vehicles', { params: { page: this.dataList.options.page, limit: 10, search } });

                this.dataList.data = result.data.content.data;
                // this.dataList.count = this.dataList.data.length;
                this.dataList.count = result.data.content.total

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        openUpdateKmModal(item) {
            this.vehicleToUpdateKm = { ...item };
            this.newKm = item.current_km;
            this.showUpdateKmModal = true;
            this.$nextTick(() => {
                if (this.$refs.kmForm) {
                    this.$refs.kmForm.resetValidation();
                }
            });
        },

        closeUpdateKmModal() {
            this.showUpdateKmModal = false;
            this.newKm = null;
            this.vehicleToUpdateKm = {};
        },

        async updateKm() {
            if (!this.$refs.kmForm.validate()) {
                this.$dialog.notify.warn('Por favor, insira uma quilometragem válida.', {
                    position: 'top-right',
                    timeout: 2000
                });
                return;
            }

            this.updatingKm = true;
            try {
                const vehicleId = this.vehicleToUpdateKm.id;

                await axios.patch(`/api/v2/vehicles/${vehicleId}/odometer`, { odometer: this.newKm });

                this.$dialog.notify.info('Quilometragem atualizada com sucesso!', { position: "top-right", timeout: 2000 });
                this.closeUpdateKmModal();
                this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || 'Ocorreu um erro ao atualizar a quilometragem!', {
                    position: 'top-right',
                    timeout: 5000
                });
                console.error("Erro ao atualizar KM:", error);
            } finally {
                this.updatingKm = false;
            }
        },


        getColorByType(type) {
            switch (type) {
                case 1:
                    return 'gray'
                case 2:
                    return 'silver'
                case 3:
                    return 'white'
                case 4:
                    return 'black'
                case 5:
                    return 'blue'
                default:
                    break;
            }
        },

        editItem(item) {
            this.$router.push(`veiculos/${item.id}`);
        },

        async deleteItem(item) {

            if (!item || !item.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Excluir veículo',
                actions: {
                    false: 'Cancelar',
                    true: 'Excluir'
                }
            })

            if (!proceedAction) return;

            this.dataList.loading = true

            try {

                const result = await axios.delete(`api/v2/vehicles/${item.id}`)

                this.$dialog.notify.info("Veículo excluído com sucesso!", { position: "top-right", timeout: 2000 });

                this.load()

            } catch (error) {

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })

            } finally {
                this.dataList.loading = false;
            }

        },

    },
};
</script>

<style lang="scss">
.private-image {
    object-fit: contain !important;
}
</style>
